import { render } from "./ReportNotification.vue?vue&type=template&id=649a6092&ts=true"
import script from "./ReportNotification.vue?vue&type=script&lang=ts"
export * from "./ReportNotification.vue?vue&type=script&lang=ts"

import "./ReportNotification.vue?vue&type=style&index=0&id=649a6092&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__